import Vue from 'vue';
import http from './http_services'
import methode from './mod_methode'

const lists = {
	state: {
		master_lists: [],
		cached_lists: {}
	},

	check_if_list_cached: function(list_id) {
		let found_list = false;
		let vm = this;

		// LOOP THROUGH CACHED OBJECTS
		for(var key in vm.state.master_lists) {
			if(vm.state.master_lists[key].list_id == list_id) {
			found_list = vm.state.master_lists[key];
			}
		}

		return found_list;
	},

	get_cms_list2: function(list_id, limit) {
		let vm = this;

		// CHECK IF LIST ALREADY IN STATE
		if(vm.state.cached_lists[list_id]) {
			// RETURN CACHED LIST IF EXISTS
			return vm.state.cached_lists[list_id];
		}
		else {
			// GET LIST FROM CMS
			methode.fetch_methode_api_data(list_id, limit)
				.then(function(response) {
					// console.log('response: ', response);

					let normalized_list = methode.normalize_api_data(response.data);
					// console.log('normalized_list: ', normalized_list);

					// STORE LIST IN STATE
					Vue.set(vm.state.cached_lists, list_id, normalized_list);

					// RE-RUN THIS METHOD TO GET LIST FROM CACHE
					vm.get_cms_list2(list_id);
				})
		}

	},

	get_cms_list: function(list_id) {
		// CHECK IF LIST ALREADY CACHED
		let vm = this;
		let cached_list = vm.check_if_list_cached(list_id);
		

		// RETURN CACHED LIST IF EXISTS
		if(cached_list !== false) {
			return cached_list;
		}
		else {
			// GET LIST FROM CMS
			http.get_cms_list(list_id)
			.then(function(response) {

				// APPEND LIST ID TO OBJECT
				response.data.list_id = list_id;

				// STORE LIST
				vm.state.master_lists.push(response.data);

				vm.get_cms_list(list_id);
			})
			
		}

	},

}

export default lists


// WEBPACK FOOTER //
// ./src/store/modules/mod_lists.js